<script setup lang="ts">
import Menu_elements from "~/components/menu/menu_elements.vue";
import { useGlobalDialog } from '@/composables/useGlobalDialog'

const settingsStore = useSettingsStore();
const { settings } = storeToRefs(settingsStore);
const route = useRoute();
const isDigitalMenu = computed(() => String(route.name ?? "").startsWith("menu"));
const previewEnabled = useState<boolean>('palette-preview-enabled', () => false);

const footerComponent = defineAsyncComponent(
  () => import("~/components/footerComponent.vue"),
);
const CookieConsentModal = defineAsyncComponent(
  () => import("~/components/CookieConsentModal.vue"),
);
const AppDialogHost = defineAsyncComponent(
  () => import("~/components/AppDialogHost.vue"),
);

const {
    isOpen,
    dialogWidth,
    dialogTitle,
    dialogComponent,
    dialogProps,
    closeDialog,
    finishDialog,
} = useGlobalDialog()


// set google search console tag
useHead(() => ({
    meta: settings.value.google_search_console
        ? [
            {
                name: 'google-site-verification',
                content: settings.value.google_search_console,
            },
        ]
        : [],
    link: settings.value.css_hash
        ? [{ key: 'storefront-theme', rel: 'stylesheet', href: `/theme.css?v=${encodeURIComponent(settings.value.css_hash)}` }]
        : [],
}))
const productsStore=useProductStore();

onMounted( () => {
  // load async
  void Promise.allSettled([
    productsStore.loadOptions(),
    productsStore.loadCategories(),
  ]).then((results) => {
    results.forEach((result) => {
      if (result.status === 'rejected') {
        console.error('Preload failed:', result.reason);
      }
    });
  });
});
</script>

<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <menu_elements v-if="!isDigitalMenu" />
    <main style="min-height: 400px">
      <NuxtPage />
      <AppDialogHost
          v-if="isOpen"
          v-model="isOpen"
          :width="dialogWidth"
          :title="dialogTitle"
          :component="dialogComponent"
          :component-props="dialogProps"
          @close="closeDialog"
          @result="finishDialog"
      />
    </main>
    <ClientOnly>
      <cookie-consent-modal v-if="!previewEnabled" />
    </ClientOnly>
    <footer-component v-if="!isDigitalMenu" />
  </NuxtLayout>
  <ClientOnly>
    <LazyPalettePreview v-if="previewEnabled" />
  </ClientOnly>
</template>
<style scoped>
header{
  position: sticky;
  top: 0;
  z-index: 1000;
  background:white;
}
</style>
